function addProductToRecentlyViewed() {
  let recentlyViewedList = localStorage.getItem('recently-viewed-products') || [];

  if (recentlyViewedList && recentlyViewedList.length > 0) recentlyViewedList = JSON.parse(recentlyViewedList);
  const productHandle = window.location.pathname.split('/products/')[1].split('?')[0];

  // remove product from list if it is already in the list so we can add it at the front 
  if (recentlyViewedList.includes(productHandle)) {
    recentlyViewedList = recentlyViewedList.filter(id => id !== productHandle);
  }
  // add product to the front of the list
  recentlyViewedList.unshift(productHandle);

  // limit the list to 11 products (10 to show + 1 for the current product)
  recentlyViewedList = recentlyViewedList.slice(0, 11);

  // save the list to localStorage
  localStorage.setItem('recently-viewed-products', JSON.stringify(recentlyViewedList));
}

if (window.location.pathname.includes('/products/')) {
  addProductToRecentlyViewed();
}
